import React from "react";
import Helmet from "react-helmet";
import Layout from "../common/layouts/";
import Seo from "../common/seo";
import "tachyons";

export default () => (
  <Layout>
    <Seo title="Terms & Conditions" description="Terms and conditions" />
    <Helmet>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>{" "}
    <div className="bg-style-bl pv5 flex flex-column items-center">
      <h1 className="db f1 display fw1"> Terms & Conditions </h1>{" "}
      <p className="db sans-serif f5 tracked ttu tc">
        {" "}
        Effective date: December 19, 2018{" "}
      </p>{" "}
    </div>{" "}
    <div className="lh-copy f4 serif mw8 center">
      {" "}
      <a
        className="style-pr"
        href="https://www.iubenda.com/privacy-policy/22415670"
      >
        {" "}
        Privacy Policy{" "}
      </a>
      <h2>1. ACCEPTANCE OF TERMS</h2>
      <p>
        {" "}
        The services that Bookbot Pty Ltd provides to User is subject to the
        following Terms of Use ("TOU"). Bookbot Pty Ltd reserves the right to
        update the TOU at any time without notice to User. The most current
        version of the TOU can be reviewed by clicking on the "Terms of Use"
        hypertext link located at the bottom of our Web pages.{" "}
      </p>{" "}
      <p>
        {" "}
        A. This Agreement, which incorporates by reference other provisions
        applicable to use of BookbotKids.com and the Bookbot app, including, but
        not limited to, supplemental terms and conditions set forth hereof
        ("Supplemental Terms") governing the use of certain specific material
        contained in BookbotKids.com and the Bookbot app, sets forth the terms
        and conditions that apply to use of BookbotKids.com and the Bookbot app
        by User. By using Bookbot Pty Ltd (other than to read this Agreement for
        the first time), User agrees to comply with all of the terms and
        conditions hereof. The right to use BookbotKids.com and the Bookbot app
        is personal to User and is not transferable to any other person or
        entity. User is responsible for all use of User's Account (under any
        screen name or password) and for ensuring that all use of User's Account
        complies fully with the provisions of this Agreement. User shall be
        responsible for protecting the confidentiality of User's password(s), if
        any.
      </p>
      <h2>2. CHANGED TERMS</h2>
      <p>
        {" "}
        Bookbot Pty Ltd shall have the right at any time to change or modify the
        terms and conditions applicable to User's use of BookbotKids.com and the
        Bookbot app, or any part thereof, or to impose new conditions,
        including, but not limited to, adding fees and charges for use. Such
        changes, modifications, additions or deletions shall be effective
        immediately upon notice thereof, which may be given by means including,
        but not limited to, posting on BookbotKids.com, or by electronic or
        conventional mail, or by any other means by which User obtains notice
        thereof. Any use of BookbotKids.com and the Bookbot app by User after
        such notice shall be deemed to constitute acceptance by User of such
        changes, modifications or additions.{" "}
      </p>{" "}
      <p>
        {" "}
        We use your data to provide and improve the Service.By using the
        Service, you agree to the collection and use of information in
        accordance with this policy.Unless otherwise defined in this Privacy
        Policy, terms used in this Privacy Policy have the same meanings as in
        our Terms and Conditions, accessible from gatsby - starter -
        tyra.netlify.com{" "}
      </p>{" "}
      <h2>3. DESCRIPTION OF SERVICES</h2>
      <p>
        {" "}
        Through its Web property, Bookbot Pty Ltd provides User with access to a
        variety of resources, including download areas, communication forums and
        product information (collectively "Services"). The Services, including
        any updates, enhancements, new features, and/or the addition of any new
        Web properties, are subject to the TOU.{" "}
      </p>{" "}
      <h2>4. PAYMENTS AND CANCELLATIONS</h2>
      <p>
        {" "}
        Information on our subscription fee can be found on the Bookbot pricing
        page https://www.bookbotkids.com/pricing. It will remain fixed during
        the subscription term, until reading profiles are added or removed.
        Charges are processed using your preferred payment method (Credit Card,
        PayPal or in-app purchase). All fees may be exclusive of all taxes,
        levies, or duties imposed by taxing authorities, and you shall be
        responsible for payment of all such taxes, levies, or duties. Downgrade
        or Upgrade: A downgrade or upgrade in plan level, will result in a
        prorated credit of the remaining billed month or year, with the new rate
        being charged immediately. Cancellation: You are solely responsible for
        properly cancelling your account. An email or support request to cancel
        your account is not considered a cancellation. You can cancel your
        account by visiting the Account Management link found in the footer of
        the page. If you need assistance you may also use the Support or Contact
        link found in the footer of the web site. If you cancel your
        subscription before the end of your current paid up month or year, you
        will not be charged again. However, you will still have access to the
        content from the app until the end of that term. Payments referred to
        herein shall not be refundable under any circumstances, including but
        not limited to the termination of this agreement for whatever reason.
        The company, in its sole discretion, has the right to suspend or
        terminate your account and refuse any and all current or future use of
        the service for any reason at any time. Such termination of the service
        will result in the deactivation or deletion of your account or access to
        the Bookbot app, and the forfeiture and relinquishment of all content in
        your account. Bookbot Pty Ltd reserves the right to refuse service to
        anyone for any reason at any time.{" "}
      </p>{" "}
      <h2>5. EQUIPMENT</h2>
      <p> paragraph </p>
      <h2>6. USER CONDUCT</h2>
      <p> paragraph </p>
      <h2>7. USE OF SERVICES</h2>
      <p> paragraph </p>
      <h2>8. MEMBER ACCOUNT, PASSWORD, AND SECURITY</h2>
      <p> paragraph </p>{" "}
      <h2>9. NOTICE SPECIFIC TO SOFTWARE AVAILABLE ON THIS WEBSITE</h2>
      <p> paragraph </p>
      <h2>10. NOTICE SPECIFIC TO DOCUMENTS AVAILABLE ON THIS WEBSITE</h2>
      <p>
        {" "}
        Permission to use Documents (such as white papers, press releases,
        data-sheets and FAQs) from the Services is granted, provided that (1)
        the below copyright notice appears in all copies and that both the
        copyright notice and this permission notice appear, (2) use of such
        Documents from the Services is for informational and non-commercial or
        personal use only and will not be copied or posted on any network
        computer or broadcast in any media, and (3) no modifications of any
        Documents are made. Accredited educational institutions, such as
        universities, private/public colleges, and state community colleges, may
        download and reproduce the Documents for distribution in the classroom.
        Distribution outside the classroom requires express written permission.
        Use for any other purpose is expressly prohibited by law, and may result
        in severe civil and criminal penalties. Violators will be prosecuted to
        the maximum extent possible. BOOKBOT PTY LTD AND/OR ITS RESPECTIVE
        SUPPLIERS MAKE NO REPRESENTATIONS ABOUT THE SUITABILITY OF THE
        INFORMATION CONTAINED IN THE DOCUMENTS AND RELATED GRAPHICS PUBLISHED AS
        PART OF THE SERVICES FOR ANY PURPOSE. ALL SUCH DOCUMENTS AND RELATED
        GRAPHICS ARE PROVIDED "AS IS" WITHOUT WARRANTY OF ANY KIND. BOOKBOT PTY
        LTD AND/OR ITS RESPECTIVE SUPPLIERS HEREBY DISCLAIM ALL WARRANTIES AND
        CONDITIONS WITH REGARD TO THIS INFORMATION, INCLUDING ALL WARRANTIES AND
        CONDITIONS OF MERCHANTABILITY, WHETHER EXPRESS, IMPLIED OR STATUTORY,
        FITNESS FOR A PARTICULAR PURPOSE, TITLE AND NON-INFRINGEMENT. IN NO
        EVENT SHALL BOOKBOT PTY LTD AND/OR ITS RESPECTIVE SUPPLIERS BE LIABLE
        FOR ANY SPECIAL, INDIRECT OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
        WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
        ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
        OR IN CONNECTION WITH THE USE OR PERFORMANCE OF INFORMATION AVAILABLE
        FROM THE SERVICES. THE DOCUMENTS AND RELATED GRAPHICS PUBLISHED ON THE
        SERVICES COULD INCLUDE TECHNICAL INACCURACIES OR TYPOGRAPHICAL ERRORS.
        CHANGES ARE PERIODICALLY ADDED TO THE INFORMATION HEREIN. BOOKBOT PTY
        LTD AND/OR ITS RESPECTIVE SUPPLIERS MAY MAKE IMPROVEMENTS AND/OR CHANGES
        IN THE PRODUCT(S) AND/OR THE PROGRAM(S) DESCRIBED HEREIN AT ANY TIME.
      </p>
      <h2>
        11. NOTICES REGARDING SOFTWARE, DOCUMENTS AND SERVICES AVAILABLE ON THIS
        SITE
      </h2>
      <p>
        {" "}
        IN NO EVENT SHALL BOOKBOT PTY LTD AND/OR ITS RESPECTIVE SUPPLIERS BE
        LIABLE FOR ANY SPECIAL, INDIRECT OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
        WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
        ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
        OR IN CONNECTION WITH THE USE OR PERFORMANCE OF SOFTWARE, DOCUMENTS,
        PROVISION OF OR FAILURE TO PROVIDE SERVICES, OR INFORMATION AVAILABLE
        FROM THE SERVICES.{" "}
      </p>
      <h2>
        12. MATERIALS PROVIDED TO BOOKBOT PTY LTD OR POSTED AT ANY OF ITS
        WEBSITES
      </h2>
      <p>
        Bookbot Pty Ltd does not claim ownership of the materials User provide
        to Bookbot Pty Ltd (including feedback and suggestions) or post, upload,
        input or submit to any Services or its associated services for review by
        the general public, or by the members of any public or private
        community, (each a "Submission" and collectively "Submissions").
        However, by posting, uploading, inputting, providing or submitting
        ("Posting") User’s Submission User is granting Bookbot Pty Ltd, its
        affiliated companies and necessary sublicensees permission to use User’s
        Submission in connection with the operation of their Internet businesses
        (including, without limitation, all Bookbot Pty Ltd Services),
        including, without limitation, the license rights to: copy, distribute,
        transmit, publicly display, publicly perform, reproduce, edit, translate
        and reformat User’s Submission; to publish User’s name in connection
        with User’s Submission; and the right to sublicense such rights to any
        supplier of the Services.
      </p>
      <p>
        No compensation will be paid with respect to the use of User’s
        Submission, as provided herein. Bookbot Pty Ltd is under no obligation
        to post or use any Submission User may provide and Bookbot Pty Ltd may
        remove any Submission at any time in its sole discretion. By Posting a
        Submission User warrants and represents to own or otherwise control all
        of the rights to User’s Submission as described in these Terms of Use
        including, without limitation, all the rights necessary for User to
        provide, post, upload, input or submit the Submissions.
      </p>
      <p>
        In addition to the warranty and representation set forth above, by
        Posting a Submission that contain images, photographs, pictures or that
        are otherwise graphical in whole or in part ("Images"), User warrant and
        represent that (a) User is the copyright owner of such Images, or that
        the copyright owner of such Images has granted User permission to use
        such Images or any content and/or images contained in such Images
        consistent with the manner and purpose of User’s use and as otherwise
        permitted by these Terms of Use and the Services, (b) User have the
        rights necessary to grant the licenses and sub-licenses described in
        these Terms of Use, and (c) that each person depicted in such Images, if
        any, has provided consent to the use of the Images as set forth in these
        Terms of Use, including, by way of example, and not as a limitation, the
        distribution, public display and reproduction of such Images and (d) all
        so-called moral rights in your content have been waived to the full
        extent allowed by law. By Posting Images, User is granting (a) to all
        members of User’s private community (for each such Images available to
        members of such private community), and/or (b) to the general public
        (for each such Images available anywhere on the Services, other than a
        private community), permission to use User’s Images in connection with
        the use, as permitted by these Terms of Use, of any of the Services,
        (including, by way of example, and not as a limitation, making prints
        and gift items which include such Images), and including, without
        limitation, a non-exclusive, world-wide, royalty-free license to: copy,
        distribute, transmit, publicly display, publicly perform, reproduce,
        edit, translate and reformat User’s Images without having User’s name
        attached to such Images, and the right to sublicense such rights to any
        supplier of the Services. The licenses granted in the preceding
        sentences for a Images will terminate at the time User completely remove
        such Images from the Services, provided that, such termination shall not
        affect any licenses granted in connection with such Images prior to the
        time User completely remove such Images. No compensation will be paid
        with respect to the use of User’s Images.
      </p>
      <p>
        Excluding any of your content that you may provide, you acknowledge that
        all of the intellectual property and other proprietary rights in and to
        our website and the Content are owned by us and our licensors. Neither
        these Terms of Use (nor your access to our website) transfers to you or
        any third party any rights, title or interest in or to such intellectual
        property or other proprietary rights, except for the limited right to
        use our website as expressly set forth above. There are no implied
        licenses granted under these Terms of Use. All right, title and interest
        not expressly granted with respect to our website and its Content are
        reserved by us.{" "}
      </p>{" "}
      <h2 className="sans-serif"> Contact Us </h2>{" "}
      <p>
        {" "}
        If you have any questions about this Privacy Policy, please contact us:{" "}
      </p>{" "}
      <ul>
        <li> by email contact@bookbotkids.com </li>{" "}
      </ul>{" "}
    </div>{" "}
  </Layout>
);
